// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","textDefault":"#808080","header-icon":"_3RT8fMjaK6QURY0nlojbc0","sidebar-toggler":"_1kl917PSdGj0poLxRaPc0D"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MainHeader/components/HeaderIcon.mod.css
// module id = 1009
// module chunks = 0